// Mock data for Strategos landing page

export const heroData = {
  title: "Strategos",
  subtitle: "Learn. Connect. Lead.",
  description: "Empowering organizations and professionals with strategic policy insights, expert-led education, and cutting-edge research capabilities.",
  ctaPrimary: "Schedule Demo",
  ctaSecondary: "Explore Solutions",
  backgroundImage: "https://images.unsplash.com/photo-1517048676732-d65bc937f952"
};

export const trustedByData = {
  title: "Trusted by Leading Organizations Worldwide",
  logos: [
    { name: "Harvard Kennedy School", type: "education" },
    { name: "World Bank", type: "global" },
    { name: "McKinsey & Company", type: "consulting" },
    { name: "United Nations", type: "international" },
    { name: "Brookings Institution", type: "thinktank" },
    { name: "RAND Corporation", type: "research" }
  ]
};

export const metricsData = [
  {
    id: 1,
    value: "500+",
    label: "Enterprise Clients",
    subtext: "Fortune 500 & Government Agencies"
  },
  {
    id: 2,
    value: "98%",
    label: "Client Satisfaction",
    subtext: "Based on 2,000+ Reviews"
  },
  {
    id: 3,
    value: "50+",
    label: "Countries Served",
    subtext: "Global Policy Impact"
  },
  {
    id: 4,
    value: "$2.5B+",
    label: "Policy Impact",
    subtext: "Economic Value Generated"
  }
];

export const statsData = [
  {
    id: 1,
    value: 15000,
    suffix: "+",
    label: "Active Students",
    icon: "Users"
  },
  {
    id: 2,
    value: 120,
    suffix: "+",
    label: "Expert Courses",
    icon: "BookOpen"
  },
  {
    id: 3,
    value: 95,
    suffix: "%",
    label: "Completion Rate",
    icon: "TrendingUp"
  },
  {
    id: 4,
    value: 12000,
    suffix: "+",
    label: "Career Advances",
    icon: "Award"
  }
];

export const featuresData = [
  {
    id: 1,
    title: "Virtual Business Policy Adviser",
    subtitle: "Enterprise Solutions",
    description: "AI-powered strategic policy advisory platform for enterprises, government agencies, and institutional clients. Deliver actionable insights with precision and speed.",
    image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxkYXNoYm9hcmQlMjBhbmFseXRpY3N8ZW58MHx8fHwxNzcyMDE5MzUzfDA&ixlib=rb-4.1.0&q=85",
    icon: "Building2",
    features: [
      "Advanced AI-powered policy analysis",
      "Real-time regulatory intelligence",
      "Enterprise-grade security & compliance",
      "Dedicated account management",
      "Custom integration capabilities"
    ],
    color: "from-red-50 to-red-100"
  },
  {
    id: 2,
    title: "Academy",
    subtitle: "Professional Development",
    description: "Executive education programs designed for policy professionals, government leaders, and strategic advisors. Accredited certifications from industry experts.",
    image: "https://images.unsplash.com/photo-1501504905252-473c47e087f8?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwzfHxvbmxpbmUlMjBsZWFybmluZ3xlbnwwfHx8fDE3NzIwMTkzNTd8MA&ixlib=rb-4.1.0&q=85",
    icon: "GraduationCap",
    features: [
      "Executive-level curriculum",
      "Industry-recognized certifications",
      "Expert faculty & practitioners",
      "Flexible learning formats",
      "Continuing education credits"
    ],
    color: "from-blue-50 to-blue-100"
  },
  {
    id: 3,
    title: "Think Tank Interface",
    subtitle: "Strategic Research",
    description: "Access elite research capabilities for high-stakes policy challenges. Our network of senior advisors delivers institutional-grade analysis and strategic recommendations.",
    image: "https://images.unsplash.com/photo-1588600878108-578307a3cc9d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHwxfHxyZXNlYXJjaCUyMGFuYWx5c2lzfGVufDB8fHx8MTc3MjAxOTM2Mnww&ixlib=rb-4.1.0&q=85",
    icon: "Brain",
    features: [
      "Senior expert advisory network",
      "Confidential research protocols",
      "Peer-reviewed analysis",
      "Strategic scenario planning",
      "White-glove service delivery"
    ],
    color: "from-slate-50 to-slate-100"
  },
  {
    id: 4,
    title: "Community",
    subtitle: "Professional Network",
    description: "Join an exclusive network of policy leaders, government officials, and strategic advisors. Collaborate, share insights, and advance your professional impact.",
    image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHw1fHx0ZWFtJTIwY29sbGFib3JhdGlvbnxlbnwwfHx8fDE3MzU0MzY4MDB8MA&ixlib=rb-4.1.0&q=85",
    icon: "Users",
    features: [
      "Vetted professional membership",
      "Executive networking events",
      "Knowledge exchange forums",
      "Collaborative research opportunities",
      "Annual leadership summit"
    ],
    color: "from-green-50 to-green-100"
  }
];

export const benefitsData = [
  {
    id: 1,
    title: "Expert-Led Learning",
    description: "Learn from top policy professionals, legislative experts, and real-world practitioners with decades of experience.",
    icon: "UserCheck"
  },
  {
    id: 2,
    title: "Global Community",
    description: "Connect with a thriving network of professionals, consultants, and experts from around the world.",
    icon: "Globe"
  },
  {
    id: 3,
    title: "Career-Focused",
    description: "Transform your skills into earning opportunities. Become a certified consultant and work on real client projects.",
    icon: "Target"
  },
  {
    id: 4,
    title: "Learn at Your Pace",
    description: "Flexible learning experience designed for busy professionals. Access courses anytime, anywhere.",
    icon: "Clock"
  }
];

export const testimonialsData = [
  {
    id: 1,
    name: "Sarah Jenkins",
    role: "Policy Analyst",
    company: "Global Insights Corp",
    rating: 5,
    text: "Strategos completely transformed my approach to policy analysis. The courses are world-class, and the consultant network is invaluable for my ongoing projects.",
    avatar: "SJ"
  },
  {
    id: 2,
    name: "Michael Chen",
    role: "Legislative Affairs",
    company: "TechStart Inc",
    rating: 5,
    text: "The comprehensive LMS and practical curriculum helped me advance my career. I'm now a certified consultant, working with clients I never thought possible.",
    avatar: "MC"
  },
  {
    id: 3,
    name: "Elena Rodriguez",
    role: "Government Relations",
    company: "Advocacy Partners",
    rating: 5,
    text: "The Think Tank experts provide unmatched research quality. Their insights have been instrumental in shaping our policy recommendations.",
    avatar: "ER"
  },
  {
    id: 4,
    name: "David Thompson",
    role: "Startup Founder",
    company: "InnovateLab",
    rating: 5,
    text: "The B2B Portal makes it seamless to access expert consultants. The credit system is transparent, and the quality of deliverables is consistently exceptional.",
    avatar: "DT"
  },
  {
    id: 5,
    name: "Priya Sharma",
    role: "Senior Consultant",
    company: "Strategic Solutions",
    rating: 5,
    text: "From learner to consultant - Strategos gave me the skills, certification, and platform to build a thriving consulting practice. The community support is phenomenal.",
    avatar: "PS"
  }
];

export const ctaData = {
  title: "Ready to Start Your Journey?",
  subtitle: "Join our community today and take the next step in becoming a leader in policy and strategic consulting.",
  icon: "🚀",
  primaryButton: "Explore Courses",
  secondaryButton: "Learn More About Us"
};

export const footerData = {
  brandName: "Strategos",
  tagline: "Learn. Connect. Lead.",
  description: "A revolutionary platform connecting clients, consultants, and thought leaders in policy, research, and strategic consulting.",
  quickLinks: [
    { label: "About Us", href: "#" },
    { label: "Features", href: "#" },
    { label: "Pricing", href: "#" },
    { label: "Contact", href: "#" }
  ],
  resources: [
    { label: "Learning Center", href: "#" },
    { label: "Case Studies", href: "#" },
    { label: "Documentation", href: "#" },
    { label: "Blog", href: "#" }
  ],
  legal: [
    { label: "Privacy Policy", href: "#" },
    { label: "Terms of Service", href: "#" },
    { label: "Cookie Policy", href: "#" }
  ],
  social: {
    twitter: "#",
    linkedin: "#",
    facebook: "#",
    instagram: "#"
  }
};
